import { rem } from 'polished';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { translate } from '@vimeo/i18n-runtime';
import {
  AlbumsPlaybackEmptystateDark,
  AlbumsPlaybackEmptystateLight,
} from '@vimeo/iris/illustration';
import { themes } from '@vimeo/iris/themes';
import { Header, Paragraph } from '@vimeo/iris/typography';

import { THEME_DARK } from '../../utils/constants';

interface Props {
  isOwnerOrAdmin: boolean;
  theme: string;
}

/**
 * Empty album state component
 */
const EmptyAlbum = ({ isOwnerOrAdmin, theme }: Props) => {
  return (
    <EmptyAlbumStyled>
      <IconContainer>
        {theme === THEME_DARK ? (
          <AlbumsPlaybackEmptystateDark />
        ) : (
          <AlbumsPlaybackEmptystateLight />
        )}
      </IconContainer>
      {isOwnerOrAdmin && (
        <div>
          <Header size="3" theme={theme === THEME_DARK ? themes.dark : themes.light}>
            {translate('No videos')}
          </Header>
          <Paragraph size="2" theme={theme === THEME_DARK ? themes.dark : themes.light}>
            {translate({
              singular:
                'You can add your own videos from {LINK}All videos{/LINK}, or add other videos as you discover them on Vimeo.',
              replacements: {
                LINK: (children: ReactNode) => (
                  <a href="/manage/videos" key="manage-link">
                    {children}
                  </a>
                ),
              },
            })}
          </Paragraph>
        </div>
      )}
    </EmptyAlbumStyled>
  );
};

export default EmptyAlbum;

const EmptyAlbumStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-flow: column;
  p {
    width: 350px;
  }
  a {
    text-decoration: underline;
  }
  svg {
    width: 64px;
  }
`;

const IconContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: ${rem(15)} 0 ${rem(5)};
  svg {
    width: ${rem(200)};
  }
`;
